export default __webpack_public_path__ + "static/media/icon_pleiq_learning.bf3d79e2.png";